<template>
  <div ref="box" class="media-box none-border record">
    <el-card v-if="info0">
      <el-page-header v-if="info0.id" slot="header" @back="goBack" title="">
        <div slot="content" class="flex flex-v-center">
          <div class="flex flex-v-center">
            <div style="margin-left: -10px;">{{ source.type == 1 ? source.type1.title.replace("-", "") :
              $store.getters.getTag(source.tag) }}
            </div>
            <el-divider direction="vertical"></el-divider>
            <h4 class="bold">{{ $t1(source, 'title') }}</h4>
            <div class="flex">
              <el-tag effect="dark" class="margin-l">#{{ source.no }}</el-tag>
              <el-tag effect="dark" v-if="source.frequency == 1" class="margin-l">{{ $t('高频') }}</el-tag>
              <el-tag effect="dark" v-if="source.is_gmat" class="margin-l">{{ $t('机经') }}</el-tag>

              <template v-if="['WE-Core'].indexOf(source.tag) == -1">
                <el-tag effect="dark" v-if="source.type == 0 && source.level == 2" class="margin-l">{{ $t('难')
                }}</el-tag>
                <el-tag effect="dark" v-else-if="source.type == 0 && source.level == 1" class="margin-l">{{ $t('中')
                }}</el-tag>
                <el-tag effect="dark" v-else-if="source.type == 0 && source.level == 0" class="margin-l">{{ $t('简')
                }}</el-tag>
              </template>


              <el-tag effect="dark" v-if="source.is_forecast == 1" class="margin-l">{{ $t('预测') }}</el-tag>
              <el-tag effect="dark" v-if="source.is_back" class="margin-l">{{ $t('老题重回') }}</el-tag>
              <el-tag effect="dark" v-if="source.is_updated" class="margin-l">{{ $t('更新') }}</el-tag>
              <el-tag class="margin-l" v-if="['SSL', 'RL'].indexOf(source.tag) != -1" effect="dark">{{
                source.audio == 2
                  ? $t('近似音频') : source.audio == 1 ? $t('原音频') : $t('无音频')
              }}</el-tag>
            </div>
          </div>
        </div>
      </el-page-header>
      {{ }}
      <el-empty v-if="!loading && !info0.id" :description="$t('没有找到练习记录哦~')">
        <el-button @click="back()" round icon="el-icon-back" type="primary">返回</el-button>
      </el-empty>

      <div>
        <div
          v-if="['RS', 'RL', 'WFD', 'HIW', 'FIB-L', 'SMW', 'HCS', 'MCS', 'MCM-L', 'SST', 'SST-Core'].indexOf(source.tag) != -1"
          style="margin-bottom: 20px;">
          <!-- <audio-player ref="player" @play="playStart" @ended="playerEnd" :no="source.no" :sort="source.sort" /> -->
          <h4>{{ $t('原文音频') }}:</h4> <wave-player class="margin-ts"
            :src="$host + '/api/audio/' + source.no + '/Origin'"></wave-player>
        </div>


        <div v-if="['DI'].indexOf(source.tag) != -1">
          <div class="bold">{{ $t('原图') }}:</div>
          <div class="flex flex-h-center margin-t">
            <el-image fit="contain" style="width: 400px;" ref="image" @click="preview" :preview-src-list="[imageUrl()]"
              :src="imageUrl()"></el-image>
          </div>
        </div>



        <div v-else-if="['HIW', 'FIB-L', 'FIB-R', 'FIB-RW'].indexOf(source.tag) != -1">
          <h4>{{ $t(getLabel()) }}:</h4>
          <div>
            <div class="flex flex-wrap">
              <span v-for="(item, index) in words" @click="$bus.$emit('word', item.word)" class="word" :key="index"
                :class="item.class">{{ item.word }}</span>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="ls1" v-if="source.words_en">
            <h4 v-if="source.type == 0">{{ $t(getLabel()) }}:</h4>
            <div v-for="(row, index) in source.words_en.split('\n')" :key="'row' + index">
              <div v-if="source.type == 1">
                <div class="st bold"> Segment {{ index + 1 }}</div>

                <div class="flex flex-v-center st1 margin-ts">{{ $t('原文音频') }}：<wave-player
                    :src="$host + '/api/audio/ccl_' + source.no + '_' + index + '/Origin'"></wave-player>
                </div>
              </div>
              <div class="flex flex-wrap">
                <span class="word pointer" @click="$bus.$emit('word', word)"
                  v-for="(word, index1) in row.replaceAll('^', '').split(' ')" :key="'word' + index1">{{
                    word
                  }}
                </span>
              </div>

              <div v-if="source.type == 1">

                <div class="flex flex-wrap">
                  <span class="word" @click="$bus.$emit('word', word)"
                    v-for="(word, index1) in source.words_zh.split('\n')[index].replaceAll('^', '').split(' ')"
                    :key="'word' + index1">{{
                      word
                    }}
                  </span>
                </div>


                <div v-if="info0.content[index]" class="margin-t">
                  <div class="st1 flex flex-v-center">{{ $t('答案音频') }}：<wave-player controls
                      :src="$host + info0.content[index].url"></wave-player></div>

                  <div v-if="info0.content[index].result" class="margin-t padding" style="background-color: #f5f5f5;">

                    <div><span class="bold">{{ $t('参考翻译') }}:</span> {{
                      info0.content[index].result.reference_translation
                    }}</div>
                    <div class="margin-ts" v-if="info0.content[index].result.my_translation"><span class="bold">{{
                      $t('我的翻译') }}:</span> {{
                          info0.content[index].result.my_translation }}
                    </div>
                    <div class="margin-ts" v-if="info0.content[index].result.error_analysis"><span class="bold">{{
                      $t('错误分析') }}:</span> {{
                          info0.content[index].result.error_analysis }}
                    </div>
                  </div>
                </div>
                <div v-else class="margin-t st">{{ $t('未作答') }}!</div>


                <div v-if="info0.audit_content[index]" class="margin-ts">
                  <div class="st">{{ $t('老师回复') }}：</div>
                  <div>{{ info0.audit_content[index].text }}</div>
                  <div class="margin-t" v-if="info0.audit_content[index].url"><wave-player controls
                      :src="$host + info0.audit_content[index].url"></wave-player></div>
                </div>
                <el-divider></el-divider>
              </div>

            </div>
            <template v-if="source.type == 1 && info0.result">
              <div class="bold">
                {{ $t('得分') }}：<span class="color-primary">{{ info0.result.final_score }}</span> / 45
              </div>
              <div class="margin-t bold">
                {{ $t('总结') }}：{{ info0.result.summary }}
              </div>
              <el-divider></el-divider>
            </template>
          </div>
        </div>

        <div class="ls1 margin-ts" v-if="source.tag == 'RS'">
          <div>{{ source.words_zh }}</div>
        </div>
      </div>

      <div v-if="info0.type == 0">
        <div v-if="info0.content && info0.content.indexOf('.wav') != -1">
          <div class="margin-lt">
            <el-table :border="true" :data="tableData" style="width: 100%">
              <el-table-column prop="item1" :label="$t('单项')" width="160px">
                <template slot-scope="scope">
                  <div>{{ $t(scope.row.item1) }}
                    <i slot="reference" @click="showDialog(scope.row.item1)"
                      class="el-icon-question lt color-green pointer"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="item2" :label="$t('得分')">
                <template slot-scope="scope">
                  <div class="st bold">{{ scope.row.item2 }}</div>
                  <el-progress v-if="source.tag != 'ASQ'" status="success" :percentage="scope.row.item4"
                    :show-text="false"></el-progress>
                  <template v-if="scope.row.item3">
                    <el-divider></el-divider>
                    <div>
                      <span class="color-primary bold">{{ $t('AI点评') }}</span>：{{ scope.row.item3 }}
                    </div>
                  </template>
                </template>

              </el-table-column>

              <!-- <el-table-column prop="item3" label="">
                                                                                                                                                                        <template slot-scope="scope">
                                                                                                                                                                          <el-progress :status="scope.row.item4 < 60 ? 'exception' : 'success'" :percentage="scope.row.item4"
                                                                                                                                                                            :show-text="false"></el-progress>
                                                                                                                                                                        </template>
                                                                                                                                                                      </el-table-column> -->
            </el-table>


          </div>


          <div class="margin-t flex flex-v-center">
            <div class="mt" v-if="source.tag == 'ASQ'">{{ $t('评分') }}：<span class="color-primary">{{ info0.score
            }}</span>
              / 1</div>
            <div class="mt" v-else>{{ $t('评分') }}：<span class="color-primary">{{ format_number(info0.score * 0.9)
            }}</span> /
              90</div>
            <wave-player class="margin-x" :src="$host + info0.content"></wave-player>
            <div class="st">{{ info0.result_time }}</div>
          </div>
          <div v-if="info">
            <el-divider>
              <div class="flex flex-v-center">
                <h3>{{ $t('AI识别') }}</h3>
              </div>
            </el-divider>
            <div v-if="source.tag == 'ASQ'">
              {{ info0.result }}
            </div>
            <div v-else>
              <div v-if="['RA', 'RS'].indexOf(source.tag) == -1" class="flex flex-h-end">
                <div class="flex flex-v-center margin-x" v-for="(item, index) in items.slice(1)" :key="index">
                  <div class="dot" :class="'v' + (index + 1)"></div>
                  <div>{{ $t(item) }}</div>
                </div>

                <div class="flex flex-v-center margin-x">
                  <div>/ {{ $t('停顿') }}</div>
                </div>
              </div>

              <div v-else class="flex flex-h-end">
                <div class="flex flex-v-center margin-x" v-for="(item, index) in items" :key="index">
                  <div class="dot" :class="'v' + index"></div>
                  <div>{{ $t(item) }}</div>
                </div>

                <div class="flex flex-v-center margin-x">
                  <div>/ {{ $t('停顿') }}</div>
                </div>
              </div>

              <div class="flex flex-wrap" v-if="info && info.words">

                <el-popover width="400" @show="showDetail(item.word)" placement="top" trigger="click"
                  v-for="(item, index) in info.words" :key="index">
                  <div class="st1">{{ item.pronunciation > 80 ? $t("发音正确，请继续保持") : item.pronunciation > 60 ?
                    $t("发音有点问题，稍作改变会更完美")
                    : item.pronunciation > 0 ? $t("发音糟糕，请听正确发音并纠正") : $t("没有读这个单词") }}</div>
                  <div class="line margin-ts"></div>
                  <h3 class="margin-ts">{{ item.word }}</h3>
                  <div class="st"><span style="margin-right: 10px;">{{ $t('你的发音') }}:</span>[<span
                      v-for="(ph, index1) in item.phonemes"
                      :class="{ 'v0': ph.pronunciation < 60, 'v1': ph.pronunciation >= 60 && ph.pronunciation <= 80, 'v2': ph.pronunciation >= 80 }"
                      :key="index1">{{ ph.phoneme }}</span>]
                  </div>
                  <div v-loading="loading1">
                    <div class="st1 flex flex-v-center">[UK]<span style="margin:0 10px;">[{{ wordInfo.phonetic[0]
                    }}]</span>
                      <el-image @click="play(1, item.word)" class="margin-x"
                        style="width: 24px; height: 24px;cursor: pointer;" src="/web/image/playing.png"></el-image>
                    </div>
                    <div class="st1 flex flex-v-center">[US]<span style="margin:0 10px;">[{{
                      wordInfo.phonetic[1] }}]</span>
                      <el-image @click="play(2, item.word)" class="margin-x"
                        style="width: 24px; height: 24px;cursor: pointer;" src="/web/image/playing.png"></el-image>
                    </div>
                    <div class="st1">
                      <div v-for="(row, index) in wordInfo.explanation.split('\n')" :key="index">
                        {{ row }}
                      </div>
                    </div>
                  </div>
                  <span slot="reference" class="word" :class="getClass(item)">{{ item.word }}
                    <span style="color:#333"
                      v-if="index < info.words.length - 1 && (info.words[index + 1].start - info.words[index].end > 0.4)">//</span>
                    <span style="color:#333"
                      v-else-if="index < info.words.length - 1 && (info.words[index + 1].start - info.words[index].end > 0.1)">/</span>

                  </span>
                </el-popover>


              </div>
              <div class="margin-t center st1">{{ $t('点击彩色单词可查看解析') }}</div>

              <template>
                <el-divider>
                  <div class="flex flex-v-center">
                    <h3 class="color-primary">{{ $t('AI提升建议') }}</h3>
                  </div>
                </el-divider>
                <div>
                  {{ info0.result.suggestion }}
                </div>
              </template>
            </div>


          </div>

          <div class="st margin-t" v-else>{{ $t('未评测') }}!</div>
        </div>

        <div v-else>
          <div v-if="['SMW', 'MCS', 'HCS', 'MCM-L', 'MCS-L', 'MCS-R', 'MCM-R'].indexOf(this.source.tag) != -1"
            class="margin-lt mt">
            <span class="word" v-for="(word, index) in source.question.split(' ')" :key="index">{{ word }}</span>
          </div>

          <div v-if="source.tag == 'HCS' || source.tag == 'MCS-L' || source.tag == 'SMW' || source.tag == 'MCS-R'">
            <div v-for="(words, index) in options" :key="index">
              <el-radio disabled class="margin-t" :label="choice[index]" v-model="content[0]">
                <span
                  :class="{ 'right': submitted == 1 && (content.indexOf(choice[index]) != -1 || answers.indexOf(choice[index]) != -1), 'wrong': submitted == 1 && content.indexOf(choice[index]) != -1 && answers.indexOf(choice[index]) == -1, 'choose': submitted == 1 && content.indexOf(choice[index]) != -1 }"
                  v-for="(word, index1) in words" :key="index1" class="word">{{ word }}</span>
                <!-- <i v-if="(submitted == 1 && content.indexOf(choice[index]) != -1 && answers.indexOf(choice[index]) != -1)"
                  style="color:green;font-weight:bold;" class="check-icon el-icon-check"></i> -->

                <!-- <i v-if="submitted == 1 && content.indexOf(choice[index]) != -1 && answers.indexOf(choice[index]) == -1"
                              style="color:red;font-weight:bold;" class="check-icon el-icon-close"></i> -->
              </el-radio>
            </div>
          </div>

          <el-checkbox-group :disabled="submitted == 1" v-if="source.tag == 'MCM-L' || source.tag == 'MCM-R'"
            v-model="content">
            <div v-for="(words, index) in options" :key="index">
              <el-checkbox class="margin-t" :label="choice[index]">
                <span v-for="(word, index1) in words" :key="index1" class="word"
                  :class="{ 'right': submitted == 1 && (content.indexOf(choice[index]) != -1 || answers.indexOf(choice[index]) != -1), 'wrong1': submitted == 1 && content.indexOf(choice[index]) != -1 && answers.indexOf(choice[index]) == -1, 'choose': submitted == 1 && content.indexOf(choice[index]) != -1 }">{{
                    word
                  }}</span>

                <!-- <i v-if="(submitted == 1 && content.indexOf(choice[index]) != -1 && answers.indexOf(choice[index]) != -1)"
                  style="color:green;font-weight:bold;" class="el-icon-check"></i> -->
                <!-- 
                <i v-if="submitted == 1 && content.indexOf(choice[index]) != -1 && answers.indexOf(choice[index]) == -1"
                  style="color:green;font-weight:bold;" class="el-icon-close"></i> -->
              </el-checkbox>
            </div>
          </el-checkbox-group>

          <div class="mt" v-if="['FIB-RW', 'WFD', 'HIW', 'FIB-L', 'MCS-R', 'MCM-R', 'FIB-R'].indexOf(source.tag) == -1">
            <el-divider></el-divider>
            <h4>{{ $t(getAnswerLabel()) }}：</h4>

            <div v-if="['SWT', 'SWT-Core', 'WE', 'WE-Core', 'SST', 'SST-Core'].indexOf(source.tag) != -1">
              <div class="flex flex-wrap" v-for="(row, index) in source.answer.replace(/\^/g, '').split('\n')"
                :key="'row' + index">
                <span class="word pointer" v-word v-for="(word, index1) in row.split(' ')" :key="'word' + index1">{{
                  word
                }}
                </span>
              </div>
            </div>
            <div v-else class="word">{{ source.answer }}</div>
          </div>
          <el-divider></el-divider>
          <div class="mt" v-if="source.tag && ['HIW', 'SMW', 'HCS', 'MCS', 'MCM-L', 'MCM-R'].indexOf(source.tag) == -1">
            <h4> {{ $t('我的答案') }}：</h4>

            <div class="flex flex-wrap" v-if="['WFD', 'FIB-RW', 'FIB-R'].indexOf(source.tag) != -1">
              <span v-word v-for="(item, index) in answers" class="mt word" :key="index" :class="item.class">{{
                item.word
              }}</span>
            </div>

            <div class="flex flex-wrap" v-else-if="['SST', 'SST-Core', 'SWT', 'SWT-Core'].indexOf(source.tag) != -1">
              <span v-for="(word, index) in info0.content.split(' ')" v-word class="mt word pointer" :key="index">{{
                word
                }}</span>
            </div>
            <div v-else-if="['WE', 'WE-Core'].indexOf(source.tag) != -1">
              <div v-for="(row, index) in info0.content.split('\n')" :key="index">
                <div v-if="row" class="flex flex-wrap">
                  <span v-for="(word, index1) in row.split(' ')" v-word class="mt word pointer" :key="index1">{{
                    word
                  }}</span>
                </div>
                <div v-else style="height: 10px;"></div>
              </div>

            </div>
            <div v-else>
              <div class="word">
                {{ info0.content.replace(/\/[^,]+/g, '') }}
              </div>
              <!-- <div v-else> {{ info0.content }}</div> -->
            </div>
          </div>


          <div class="st flex flex-between flex-v-center margin-t">
            <div><span>{{ $t('得分') }}：{{ info0.score }}</span>
              <span
                v-if="['FIB-RW', 'HIW', 'FIB-L', 'SMW', 'HCS', 'MCS', 'MCM-L', 'MCS-R', 'MCM-R', 'FIB-R'].indexOf(source.tag) != -1">/{{
                  source.answer.split(',').length
                }}</span>
              <span v-else-if="['WFD'].indexOf(source.tag) != -1">/{{ source.answer.split(' ').length }}</span>
              <span v-else-if="['SWT'].indexOf(source.tag) != -1">/9</span>
              <span v-else-if="['SWT-Core'].indexOf(source.tag) != -1">/8</span>
              <span v-else-if="['WE'].indexOf(source.tag) != -1">/26</span>
              <span v-else-if="['WE-Core'].indexOf(source.tag) != -1">/15</span>
              <span v-else-if="['SST'].indexOf(source.tag) != -1">/12</span>
              <span v-else-if="['SST-Core'].indexOf(source.tag) != -1">/10</span>
              <span v-else-if="['RO'].indexOf(source.tag) != -1">/{{ source.answer.split(',').length - 1 }}</span>
              <span style="margin-left:10px;"
                v-if="['WE', 'WE-Core', 'SWT', 'SWT-Core', 'SST', 'SST-Core'].indexOf(source.tag) != -1">{{ $t('字数')
                }}：{{
                  wordCount
                }}</span>

            </div>
            <div style="color:#999">{{ info0.record_time }}</div>
          </div>

          <div class="st">{{ $t('详细解析请见海澳英语官网') }}<a href="https://www.ptefighter.com"
              class="margin-x ul">www.ptefighter.com</a>
          </div>

          <el-table class="margin-lt"
            v-if="source.tag == 'SWT' || source.tag == 'SWT-Core' || source.tag == 'WE' || source.tag == 'WE-Core' || source.tag == 'SST' || source.tag == 'SST-Core'"
            :border="true" :data="tableData" style="width: 100%">
            <el-table-column prop="item1" :label="$t('评分项')">
              <template slot-scope="scope">
                <div>{{ scope.row.item1 }}
                  <i slot="reference" @click="showDialog(scope.row.item1)"
                    class="el-icon-question lt color-green pointer"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="item2" :label="$t('得分')">
              <template slot-scope="scope">
                <div>{{ scope.row.item2 }}</div>
                <el-progress v-if="source.tag != 'ASQ'" :status="scope.row.item4 < 60 ? 'exception' : 'success'"
                  :percentage="scope.row.item4" :show-text="false"></el-progress>

                <template v-if="scope.row.item3">
                  <el-divider></el-divider>
                  <div>
                    <span class="color-primary bold">{{ $t('AI点评') }}</span>：{{ scope.row.item3 }}
                  </div>
                </template>
              </template>
            </el-table-column>

          </el-table>

          <div
            v-if="info0.source.tag == 'SWT' || info0.source.tag == 'SWT-Core' || info0.source.tag == 'WE' || info0.source.tag == 'WE-Core' || info0.source.tag == 'SST' || info0.source.tag == 'SST-Core'"
            class="margin-t">

            <div class="st bold margin-bs">
              {{ $t('AI评测结果') }}:
            </div>

            <template v-if="info.rows">
              <div v-for="(row, i) in info.rows" :key="i">
                <div v-if="row.length == 0" style="height: 10px;"></div>
                <div v-else class="flex flex-wrap">
                  <template v-for="(word, index) in row">
                    <el-popover :key="index" v-if="word.indexOf('|') != -1" placement="top-start" title=""
                      trigger="hover" :content="word.split('|')[1]">
                      <span class="pointer word" style="color:red;text-decoration: underline;" slot="reference">{{
                        word.split('|')[0] }}</span>
                    </el-popover>
                    <template v-else>
                      <span v-word :key="index"
                        :style="{ color: (word == row[index - 1] || word == row[index + 1]) ? 'red' : '' }"
                        :class="word.replace(/\W/g, '') ? 'word' : 'word-dot'" class="pointer" v-if="word">{{ word
                        }}</span>
                    </template>
                  </template>
                </div>
              </div>
            </template>
            <template v-else>
              <div v-for="(row, i) in info.words.split('\n')" :key="i">
                <div v-if="!row" style="height: 10px;"></div>
                <div v-else class="flex flex-wrap">
                  <template v-for="(word, index) in row.replace(/\./g, '. ').replace(/\s+/g, ' ').split(' ')">
                    <el-popover :key="index" v-if="word.indexOf('^') != -1" placement="top-start" title=""
                      trigger="hover" :content="word.split('^')[1]">
                      <span class="pointer word" style="color:red;text-decoration: underline;" slot="reference">{{
                        word.split('^')[0] }}</span>
                    </el-popover>
                    <template v-else>
                      <span v-word :key="index"
                        :style="{ color: (word == row.replace(/\./g, '. ').replace(/\s+/g, ' ').split(' ')[index - 1] || word == row.replace(/\./g, '. ').replace(/\s+/g, ' ').split(' ')[index + 1]) ? 'red' : '' }"
                        :class="word.replace(/\W/g, '') ? 'word' : 'word-dot'" class="pointer" v-if="word">{{ word
                        }}</span>
                    </template>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div v-if="info0.type == 1" class="st">{{ $t('详细解析请见海澳英语官网') }}<a href="https://www.ptefighter.com"
          class="margin-x ul">www.ptefighter.com</a></div>
    </el-card>



    <div v-if="ids" style="position:fixed;bottom: 0;left:0;right:0;background-color: #ccc;z-index: 1000;"
      class="padding flex flex-h-center">
      <el-button @click="next(-1)" :plain="ids.indexOf(id) == 0" :disabled="ids.indexOf(id) == 0" round class="margin-r"
        type="primary">{{ $t('上一题') }}<i class="el-icon-top"></i></el-button>
      <el-button :plain="ids.indexOf(id) == ids.length - 1" @click="next(1)"
        :disabled="ids.indexOf(id) == ids.length - 1" round classs="margin-l" type="primary">{{ $t('下一题') }}<i
          class="el-icon-bottom"></i></el-button>
    </div>

    <div v-if="ids" style="height: 100px;"></div>

    <tip-dialog ref="tipDialog"></tip-dialog>
    <word-dialog ref="wordDialog" :type="1"></word-dialog>
    <audio ref="audio"></audio>
  </div>
</template>

<script>
// import audioPlayer from '../components/AudioPlayer.vue'
import tipDialog from '../components/TipDialog.vue';
import WavePlayer from '../components/WavePlayer.vue';
import wordDialog from '../components/WordDialog.vue';
import getWFD from '../util';

export default {
  components: {
    WavePlayer, wordDialog, tipDialog
  },
  data: function () {
    return {
      loading: true,
      tag: "",
      id: 0,
      info0: {},
      info: {},
      source: {},
      tableData: [],
      items: ['漏读', '差', '良', '优'],
      words: [],
      answers: [],
      options: [],
      submitted: 1,
      choice: ["A", "B", "C", "D", "E", "F", "G"],
      content: [],
      wordInfo: { phonetic: [], explanation: "" },
      loading1: false,
      ids: null
    }
  },

  computed: {
    wordCount: function () {
      if (this.info0.content) {
        let content = this.info0.content.trim().replace(/\s+/g, ' ');
        if (content.trim()) {
          return content.trim().split(" ").length;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
  },

  created() {
    this.$bus.$on("word", (word) => {
      word = word.replace(/(^\W*)|(\W*$)/g, "");
      word = word.trim().toLowerCase();
      if (word) {
        this.$refs.wordDialog.show(word, this.source.tag);
      }
    })
    this.query()
  },

  mounted() {
    window.showWord = this.showWord
  },


  methods: {

    back() {
      this.$router.back()
    },

    format_number(val) {
      return parseFloat(val).toFixed(0);
    },
    next(val) {
      let index = this.ids.indexOf(this.id)
      index += val;
      this.$router.replace({
        path: '/record',
        query: { id: this.ids[index], immersive: 1 }
      })
      this.query()
    },
    play(type, word) {
      this.src = this.$host + "/api/word/audio/" + word + "/" + type
      this.$refs.audio.src = this.src;
      this.$refs.audio.play();
    },
    showDetail(word) {
      let info = this.$store.getters.getWord(word);
      if (info) {
        this.wordInfo.explanation = info.explanation;
        this.wordInfo.phonetic.phonetic;
      } else {
        this.loading1 = true;
        this.$http.post("/api/word/info", { word: word }).then((info) => {
          this.wordInfo = info;
          this.$store.commit("addWord", info);
          this.loading1 = false;
        });
      }
    },

    showDialog(title) {
      this.$refs.tipDialog.show(this.source.tag, title)
    },

    goBack() {
      if (this.$route.query.immersive || this.$route.query.back) {
        this.$router.go(-1)
      } else {
        this.$router.replace("/");
      }
    },

    imageUrl() {
      return this.$host + '/upload/图片/DI/' + this.source.no + '.png';
    },
    query() {
      this.loading = true


      this.id = Number(this.$route.query.id)
      this.$http.post("/api/record/info", { id: this.$route.query.id, immersive: this.$route.query.immersive }).then((info) => {
        this.info = info.result;
        this.source = info.source;
        this.info0 = info;
        if (info.ids) this.ids = info.ids;
        if (this.info0.type == 1) {
          let content = {};
          if (this.info0.content) {
            JSON.parse(this.info0.content).forEach((data, index) => {
              content[data.index] = { url: data.url, text: data.text, result: this.info0.result ? this.info0.result.segments[index] : null };
            })
          }
          this.info0.content = content;
          let audit_content = {};
          if (this.info0.audit_content) {
            JSON.parse(this.info0.audit_content).forEach((data) => {
              audit_content[data.index] = { url: data.url, text: data.text };
            })
          }

          this.info0.audit_content = audit_content;
        } else {
          this.content = this.info0.content.split(",");
        }
        if (this.source.sort == 'ccl') return


        if (['SMW', 'MCS', 'HCS', 'MCM-L', 'MCS-L', 'MCS-R', 'MCM-R', 'SST', 'SST-Core'].indexOf(this.source.tag) != -1) {
          this.answers = this.source.answer.split(',');
        }

        if (this.source.options) {
          let rows = this.source.options.replace(/\n+/g, '\n').split('\n');
          rows.forEach((row) => {
            this.options.push(row.replace(/\s+/g, ' ').split(" "));
          })
        }

        let words = [];
        let answers = [];
        if (this.source.tag == "HIW") {
          let items = this.source.question.replace(/\s+/g, ' ').split(' ');
          let results = this.info0.content.split(",");
          let index = 0;
          items.forEach((item) => {
            if (item.indexOf("/") != -1) {
              let parts = item.split("/");
              if (results[index] == parts[0]) {
                words.push({ word: results[index], class: "right choose" })
                words.push({ word: `(${parts[1]})`, class: "right" })

              } else {
                words.push({ word: `${parts[0]}`, class: "wrong1" })
                words.push({ word: `(${parts[1]})`, class: "wrong1" })
              }

              index++;
            } else {
              words.push({ word: item, class: "" })
            }
          })
          this.words = words;
          console.log(this.words);
        } else if (this.source.tag == "FIB-L" || this.source.tag == "FIB-R") {
          let items = this.source.question.replace(/\s+/g, ' ').split(' ');
          let results = this.info0.content.split(",");
          let answers = this.source.answer.split(",");
          let index = 0;
          items.forEach((item) => {
            if (item == "__" || item.indexOf("(") == 0) {
              if (results[index] == answers[index]) {
                words.push({ word: results[index], class: "right" })
              } else {
                if (results[index]) {
                  words.push({ word: results[index], class: "wrong" })
                } else {
                  words.push({ word: "______", class: 'ls0 wrong1' })
                }

                words.push({ word: `(${answers[index]})`, class: "right" })
              }
              index++;
            } else {
              words.push({ word: item, class: "" })
            }
          })
          this.words = words;
          console.log(this.words);
        } else if (this.source.tag == "FIB-RW") {
          let items = this.source.question.replace(/\s+/g, ' ').replace(/\s+\//g, '/').split(' ');
          let results = this.info0.content.split(",");
          let answers = this.source.answer.split(",");
          let index = 0;
          items.forEach((item) => {
            if (item.indexOf("(") == 0) {
              let parts = item.replace(/[()]/g, "").split("/");
              if (results[index] == answers[index]) {
                parts.forEach((part, index1) => {
                  if (index1 == 0) {
                    words.push({ word: "(", class: "divider" })
                  }
                  if (part == results[index]) {
                    words.push({ word: part, class: "right1 choose" })
                  } else {
                    words.push({ word: part, class: "" })
                  }
                  if (index1 == parts.length - 1) {
                    words.push({ word: ")", class: "divider" })
                  } else {
                    words.push({ word: "/", class: "divider" })
                  }
                })
              } else {
                parts.forEach((part, index1) => {
                  if (index1 == 0) {
                    words.push({ word: "(", class: "divider" })
                  }
                  if (part == results[index]) {
                    words.push({ word: part, class: "wrong choose" })
                  } else if (part.indexOf(answers[index]) != -1) {
                    words.push({ word: part, class: "right1" })
                  } else {
                    words.push({ word: part, class: "" })
                  }

                  if (index1 == parts.length - 1) {
                    words.push({ word: ")", class: "divider" })
                  } else {
                    words.push({ word: "/", class: "divider" })
                  }
                })
              }
              index++;
            } else {
              words.push({ word: item, class: "" })
            }
          })
          this.words = words;
          console.log(this.words);
        }

        if (this.source.tag == "WFD") {
          let items = this.source.answer.replace(/\s+/g, ',').split(',');
          let results = this.info0.content.split(",");
          results.forEach((item) => {
            if (items.indexOf(item)) {
              answers.push({ word: item, class: 'right' })
            } else {
              answers.push({ word: item, class: 'wrong' })
            }
          })
          this.answers = answers;
        } else if (this.source.tag == "FIB-RW") {
          answers = [];
          let items = this.source.answer.replace(/\s+/g, ',').split(',');
          let results = this.info0.content.split(",");
          results.forEach((item, index) => {
            if (item == items[index]) {
              answers.push({ word: item, class: 'right' })
            } else {
              if (item) {
                answers.push({ word: item, class: 'wrong' })
                answers.push({ word: "(" + items[index] + ")", class: 'wrong1' });
              } else {
                answers.push({ word: item + "(" + items[index] + ")", class: 'wrong1' })
              }

            }
            if (index < items.length - 1) {
              answers.push({ word: ",", class: 'divider' });
            }
          })
          this.answers = answers;
        } else if (this.source.tag == "FIB-R") {
          answers = [];
          let items = this.source.answer.replace(/\s+/g, ',').split(',');
          let results = this.info0.content.split(",");
          results.forEach((item, index) => {
            if (item == items[index]) {
              answers.push({ word: item, class: 'right' })
            } else {
              if (item) {
                answers.push({ word: item, class: 'wrong' })
                answers.push({ word: "(" + items[index] + ")", class: 'wrong1' });
              } else {
                answers.push({ word: item + "(" + items[index] + ")", class: 'wrong1' })
              }

            }
            if (index < items.length - 1) {
              answers.push({ word: ",", class: 'divider' });
            }
          })
          this.answers = answers;
        }

        if (this.source.tag == 'WFD') {
          let data = this.getWFDData(this.source.answer, this.info0.content);
          this.answers = data;
        }

        if (this.source.tag == "SWT" || this.source.tag == "SWT-Core") {
          const content = this.source.tag == "SWT-Core" ? 2 : 4;
          this.tableData.push({
            item1: "Content",
            item2: this.info.content + "/" + content,
            item3: this.info.content_comment,
            item4: parseInt(this.info.content / content * 100)
          })
          const form = this.source.tag == "SWT-Core" ? 2 : 1;
          this.tableData.push({
            item1: "Form",
            item2: this.info.form + "/" + form,
            item3: this.info.form_comment,
            item4: parseInt(this.info.form / form * 100)
          })
          this.tableData.push({
            item1: "Grammar",
            item2: this.info.grammar + "/2",
            item3: this.info.grammar_comment,
            item4: parseInt(this.info.grammar / 2 * 100)
          })

          this.tableData.push({
            item1: "Vocabulary",
            item2: this.info.vocabulary + "/2",
            item3: this.info.vocabulary_comment,
            item4: parseInt(this.info.vocabulary / 2 * 100)
          })
        } else if (this.source.tag == "WE") {

          this.tableData.push({
            item1: "Content",
            item2: this.info.content + "/6",
            item3: this.info.content_comment,
            item4: parseInt(this.info.content / 6 * 100)
          })

          this.tableData.push({
            item1: "Form",
            item2: this.info.form + "/2",
            item3: this.info.form_comment,
            item4: parseInt(this.info.form / 2 * 100)
          })

          this.tableData.push({
            item1: "Development, structure and coherence",
            item2: this.info.structure + "/6",
            item3: this.info.structure_comment,
            item4: parseInt(this.info.structure / 6 * 100)
          })

          this.tableData.push({
            item1: "Grammar",
            item2: this.info.grammar + "/2",
            item3: this.info.grammar_comment,
            item4: parseInt(this.info.grammar / 2 * 100)
          })


          this.tableData.push({
            item1: "General linguistic range",
            item2: this.info.linguistic + "/6",
            item3: this.info.linguistic_comment,
            item4: parseInt(this.info.linguistic / 6 * 100)
          })


          this.tableData.push({
            item1: "Vocabulary range",
            item2: this.info.vocabulary + "/2",
            item3: this.info.vocabulary_comment,
            item4: parseInt(this.info.vocabulary / 2 * 100)
          })


          this.tableData.push({
            item1: "Spelling",
            item2: this.info.spelling + "/2",
            item3: this.info.spelling_comment,
            item4: parseInt(this.info.spelling / 2 * 100)
          })
        } else if (this.source.tag == "WE-Core") {
          this.tableData.push({
            item1: "Content",
            item2: this.info.content + "/3",
            item3: this.info.content_comment,
            item4: parseInt(this.info.content / 3 * 100)
          })
          this.tableData.push({
            item1: "Email Conventions",
            item2: this.info.conventions + "/2",
            item3: this.info.conventions_comment,
            item4: parseInt(this.info.conventions / 2 * 100)
          })

          this.tableData.push({
            item1: "Form",
            item2: this.info.form + "/2",
            item3: this.info.form_comment,
            item4: parseInt(this.info.form / 2 * 100)
          })

          this.tableData.push({
            item1: "Organization",
            item2: this.info.organization + "/2",
            item3: this.info.organization_comment,
            item4: parseInt(this.info.organization / 2 * 100)
          })


          this.tableData.push({
            item1: "Vocabulary",
            item2: this.info.vocabulary + "/2",
            item3: this.info.vocabulary_comment,
            item4: parseInt(this.info.vocabulary / 2 * 100)
          })
          this.tableData.push({
            item1: "Grammar",
            item2: this.info.grammar + "/2",
            item3: this.info.grammar_comment,
            item4: parseInt(this.info.grammar / 2 * 100)
          })

          this.tableData.push({
            item1: "Spelling",
            item2: this.info.spelling + "/2",
            item3: this.info.spelling_comment,
            item4: parseInt(this.info.spelling / 2 * 100)
          })
        } else if (this.source.tag == "SST" || this.source.tag == "SST-Core") {
          const content = this.source.tag == "SST-Core" ? 2 : 4;
          this.tableData.push({
            item1: "Content",
            item2: this.info.content + "/" + content,
            item3: this.info.content_comment,
            item4: parseInt(this.info.content / content * 100)
          })

          this.tableData.push({
            item1: "Form",
            item2: this.info.form + "/2",
            item3: this.info.form_comment,
            item4: parseInt(this.info.form / 2 * 100)
          })
          this.tableData.push({
            item1: "Grammar",
            item2: this.info.grammar + "/2",
            item3: this.info.grammar_comment,
            item4: parseInt(this.info.grammar / 2 * 100)
          })


          this.tableData.push({
            item1: "Vocabulary",
            item2: this.info.vocabulary + "/2",
            item3: this.info.vocabulary_comment,
            item4: parseInt(this.info.vocabulary / 2 * 100)
          })

          this.tableData.push({
            item1: "Spelling",
            item2: this.info.spelling + "/2",
            item3: this.info.spelling_comment,
            item4: parseInt(this.info.spelling / 2 * 100)
          })
        } else if (this.source.tag == "ASQ") {
          this.tableData.push({
            item1: "内容分",
            item2: info.score + "/1",
            item3: "流利度不仅仅是不卡顿，不重复和不犹豫，还包含了意群断句，节奏感，语速适中等其他要求。",
          })
        } else {

          let integrity_total = 90
          let integrity = info.result.integrity
          let pronunciation = info.result.pronunciation
          let fluency = info.result.fluency
          if (info.result.suggestion) {
            if (this.source.tag == 'RS') {
              integrity_total = 3
            } else {
              integrity_total = 5
            }
          }

          integrity = this.format_number(integrity / 100 * integrity_total);

          pronunciation = this.format_number(0.9 * pronunciation)
          fluency = this.format_number(0.9 * fluency)

          pronunciation = Math.max(pronunciation, 10)
          fluency = Math.max(fluency, 10)

          this.tableData.push({
            item1: this.source.tag == "RTS-Core" ? "准确性" : "内容分",
            item2: integrity + "/" + integrity_total,
            item3: info.result.integrity_comment,
            item4: 0
          })

          this.tableData.push({
            item1: "发音",
            item2: pronunciation + "/90",
            item3: info.result.pronunciation_comment,
            item4: 0
          })

          this.tableData.push({
            item1: "流利度",
            item3: info.result.fluency_comment,
            item2: fluency + "/90",
            item4: 0
          })
          setTimeout(() => {
            this.tableData[0].item4 = integrity / integrity_total * 100
            this.tableData[1].item4 = pronunciation / 90 * 100
            this.tableData[2].item4 = fluency / 90 * 100
          }, 800);
        }
        // if (info && info.result) {
        //   if (this.source.tag == "ASQ") {
        //     this.tableData.push({
        //       item1: "内容分",
        //       item2: info.score + "/1",
        //       item3: "流利度不仅仅是不卡顿，不重复和不犹豫，还包含了意群断句，节奏感，语速适中等其他要求。",
        //     })
        //   } else {

        //     this.tableData.push({
        //       item1: "流利度",
        //       item2: parseInt(info.result.fluency * 0.9) < 10 ? 10 : parseInt(info.result.fluency * 0.9) + "/90",
        //       item3: "漏读或者添加单词都是一个错误。考试遇到大词难词，可以直接跳过。不建议使用something替代难词，因为这样扣分比直接跳过要高。",
        //       item4: parseInt((parseInt(info.result.fluency * 0.9) < 10 ? 10 : parseInt(info.result.fluency * 0.9)) / 90 * 100)
        //     })
        //     this.tableData.push({
        //       item1: "发音",
        //       item2: parseInt(info.result.pronunciation * 0.9) < 10 ? 10 : parseInt(info.result.pronunciation * 0.9) + "/90",
        //       item3: "发音的评分标准比较综合，一共包含以下几点: 第一，音准问题，做到元音饱满辅音清晰；第二，有重弱读和单词重音；第三，要注意连读和省读现象，第四，不能蹦单词同时不能拖音。",
        //       item4: parseInt((parseInt(info.result.pronunciation * 0.9) < 10 ? 10 : parseInt(info.result.pronunciation * 0.9)) / 90 * 100)
        //     })
        //     this.tableData.push({
        //       item1: "内容分",
        //       item2: parseInt(info.result.integrity * 0.9) < 10 ? 10 : parseInt(info.result.integrity * 0.9) + "/90",
        //       item3: "流利度不仅仅是不卡顿，不重复和不犹豫，还包含了意群断句，节奏感，语速适中等其他要求。",
        //       item4: parseInt((parseInt(info.result.integrity * 0.9) < 10 ? 10 : parseInt(info.result.integrity * 0.9)) / 90 * 100)
        //     })

        //   }
        // }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },




    getWFDData(answer, content) {
      return getWFD(answer, content)
    },



    getLabel() {
      let text = "原文";
      if (['RS', 'RA', 'RL', 'ASQ', 'WFD', 'SMW', 'HCS', 'MCS', 'MCM-L', 'SST', 'SST-Core'].indexOf(this.source.tag) != -1) {
        text = "音频文本";
      } else if (this.source.tag == "WE" || this.source.tag == "WE-Core") {
        text = "作文题目";
      }
      return text;
    },
    getAnswerLabel() {
      let text = "答案";
      if (this.source.tag == "WE" || this.source.tag == "WE-Core") {
        text = "范文";
      } else if (this.source.tag == "SWT" || this.source.tag == "SWT-Core" || this.source.tag == "SST" || this.source.tag == "SST-Core") {
        text = "参考答案";
      }
      return text;
    },


    getClass(item) {
      if (item.pronunciation == 0) {
        if (['RA', 'RS'].indexOf(this.source.tag) == -1) {
          return "v1";
        } else {
          return "v0";
        }
      } else if (item.pronunciation < 60) {
        return "v1";
      } else if (item.pronunciation < 85) {
        return "v2";
      } else if (item.pronunciation <= 100) {
        return "v3";
      }
    },

    showWord(word) {
      this.$bus.$emit('word', word);
    }
  },
};
</script>

<style scoped>
.media-box {
  width: 840px;
  margin: 40px auto;
  position: relative;
  overflow-x: hidden;
}

.media-box>>>.el-card {
  border: none !important;
}

/* 
.media-box>>>.el-card__body {
  padding: 0;
} */

.v0 {
  color: red;
}

.v1 {
  color: yellow;
}

.v2 {
  color: green;
}

.word {
  font-size: 18px;
}


.word.v0 {
  color: #909399;
}

.word.v1 {
  color: #F56C6C;
}

.word.v2 {
  color: #E6A23C;
}

.word.v3 {
  color: #67C23A;
}

.right {
  color: green;
  font-weight: bold;
}

.right1 {
  font-size: 18px;
  color: green;
  font-weight: bolder;
}

.dot {
  margin-top: 5px;
  height: 14px;
  width: 14px;
  border-radius: 50%;
}

.dot.v0 {
  background-color: #909399;
}

.dot.v1 {
  background-color: #F56C6C;
}

.dot.v2 {
  background-color: #E6A23C;
}

.dot.v3 {
  background-color: #67C23A;
}

.record>>>.el-progress.is-success .el-progress-bar__inner {
  background-color: #e6a13c;
}


.record>>>.word.right {
  color: green;
  font-weight: 500;
}

.record>>>.word.wrong,
.wrong {
  color: red;
  text-decoration: line-through;
  font-weight: 500;
}

.record>>>.word.wrong2,
.wrong2 {
  font-weight: 500;
  text-decoration: line-through;
}

.record>>>.word.wrong1,
.wrong1 {
  color: red;
  font-weight: 500;
}


.word-dot {
  line-height: 30px;
  margin-left: -2px;
  font-size: 16px;
}
</style>
